import { PageIndex, RenderedPageElementsToDisplay } from "../../state/page";

import DisplayElementsChildren from "./DisplayElementsChildren";
import { PositionContext } from "./DisplayElements";
import { useRecoilValue } from "recoil";

function PreviewElements(): JSX.Element {
	const pageIndex = useRecoilValue(PageIndex);
	const elements = useRecoilValue(RenderedPageElementsToDisplay(pageIndex));
	// //console.log("V: PreviewElements: ", pageIndex);

	// //console.log("LSI: ", leftSidePageIndex);
	// //console.log("-----");
	return (
		<>
			<PositionContext.Provider value={"top"}>
				<DisplayElementsChildren
					pageElementsToDisplay={elements}
					pageIndex={pageIndex}
					key={`preview-${pageIndex}`}
				/>
			</PositionContext.Provider>
		</>
	);
}

export default PreviewElements;
